import React from "react";

export function LargeGrantAwardees() {
  return (
    <div className="fqxi-shortcodes-largeGrantAwardees"></div>
  );
}
